const NETWORK_ERROR = /failed to fetch|networkerror|network request failed|load failed|fetch failed/i;

export const OFFLINE_MESSAGE = "Sin conexión. Revisa tu internet e inténtalo de nuevo.";

/**
 * User-facing copy for a caught error in the Spanish UI. Provider errors
 * (Supabase Auth / PostgREST, network) are English and technical, so they
 * get `fallback`; plain Errors thrown by our own code already carry
 * Spanish copy and are shown as-is.
 */
export function friendlyError(err, fallback) {
  const message = err?.message || "";
  const offline = typeof navigator !== "undefined" && navigator.onLine === false;
  if (offline || NETWORK_ERROR.test(message) || err?.name === "AuthRetryableFetchError") {
    return OFFLINE_MESSAGE;
  }
  const ownError =
    err instanceof Error && err.name === "Error" && !err.code && err.status === undefined;
  return ownError && message ? message : fallback;
}
